module.exports = __webpack_public_path__ + "static/media/mofaheads31 copy@1x.483a3914.png";